import { render, staticRenderFns } from "./EditableTextBound.vue?vue&type=template&id=2cb7d9e3&scoped=true"
import script from "./EditableTextBound.vue?vue&type=script&lang=js"
export * from "./EditableTextBound.vue?vue&type=script&lang=js"
import style0 from "./EditableTextBound.vue?vue&type=style&index=0&id=2cb7d9e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7d9e3",
  null
  
)

export default component.exports